import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
            <div className="container px-4 px-sm-0">
                <div className="row">

                    <div className="col-lg-3 col-md-6 mb-4 footer-logo">
                        <img src="Images/footer-logo.png" alt="" className="mb-4"/>
                            <h5 className="fw-bold">About Us</h5>
                            <p>Step Arena offers a relaxing environment with top-notch services to rejuvenate your mind and body.</p>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-4">
                        <h5 className="fw-bold">Quick Links</h5>
                        <ul className="list-unstyled q-links">
                            <li><a href="#" className="text-decoration-none text-white">Services</a></li>
                            <li><a href="#" className="text-decoration-none text-white">Spa Packages</a></li>
                            <li><a href="#" className="text-decoration-none text-white">Contact</a></li>
                        </ul>
                    </div>

                    <div className="col-md-3 mb-4">
                        <h5 className="fw-bold">Contact Us</h5>
                        <p>Email: info@steparena.com</p>
                        <p>Phone: +123 456 7890</p>
                        <div className="social-icons">
                            <a href="#" target="_blank"><i className="bi bi-facebook"></i></a>
                            <a href="#" target="_blank"><i className="bi bi-twitter"></i></a>
                            <a href="#" target="_blank"><i className="bi bi-instagram"></i></a>
                        </div>
                    </div>

                    <div className="col-md-3 mb-4 footer-vator">
                        <img src="Images/Vector.png" alt="" className="w-100 opacity-"/>
                    </div>

                </div>
                <div className="text-center mt-4">
                    <p>&copy; 2025 Step Arena. All rights reserved.</p>
                </div>
            </div>
        </footer>
  );
};

export default Footer;
